module.exports = __webpack_public_path__ + "img/sx_01.5592a11b.jpg";